import * as React from 'react';
import { Alert } from 'reactstrap';
import { LProps, withLocalization } from '../utils/wrappers';
import {
  CALCULATOR_ACTION_MESSAGE,
  CALCULATOR_DEFAULTS_MESSAGE,
  CALCULATOR_PAGE_COUNT,
  CalculatorProgressState,
  customizedStepsCount,
  visitedStepsCount
} from '../utils/calculatorProgress';
import { postCalculatorNavigate } from '../utils/calculatorIframeMessages';

interface Props {
  progress: CalculatorProgressState;
  requirementsMet: boolean;
  /** True after the Take Calculator pledge has awarded points. */
  actionCompleted?: boolean;
  pointsEarned?: number;
}

const CalculatorProgressBanner = ({
  t, progress, requirementsMet, actionCompleted, pointsEarned
}: LProps<Props>) => {
  const visitedCount = visitedStepsCount(progress);
  const customizedCount = customizedStepsCount(progress);
  const onSummary = progress.onSummaryPage === true;
  const earned = pointsEarned && pointsEarned > 0 ? pointsEarned : 500;

  if (actionCompleted) {
    return (
      <Alert color="success" className="cc__calculator_progress_banner">
        <div>
          <strong>
            {t('Congratulations! You earned {{points}} points.', { points: earned })}
          </strong>
        </div>
        <div style={{ marginTop: '8px' }}>
          {t('Review and customize your carbon footprint summary below or click Home or any other link to return to the Challenge. Return to the Calculator any time.')}
        </div>
      </Alert>
    );
  }

  if (requirementsMet) {
    return (
      <Alert color="success" className="cc__calculator_progress_banner">
        <div>
          <strong>{t('You completed the calculator action!')}</strong>
        </div>
        <div style={{ marginTop: '8px' }}>
          {t('Submit a short reflection below to finish and earn your points. Sharing your footprint chart is optional.')}
        </div>
        {!onSummary &&
          <div style={{ marginTop: '10px' }}>
            <button
              type="button"
              className="btn btn-link"
              style={{ padding: 0, verticalAlign: 'baseline' }}
              onClick={() => postCalculatorNavigate('/results/summary')}
            >
              {t('Review my Summary')}
            </button>
          </div>
        }
      </Alert>
    );
  }

  return (
    <Alert color="info" className="cc__calculator_progress_banner">
      <div>
        <strong>
          {t('Steps completed: {{completed}}/{{total}}', {
            completed: visitedCount,
            total: CALCULATOR_PAGE_COUNT
          })}
        </strong>
      </div>
      <div style={{ marginTop: '8px' }}>
        {t(CALCULATOR_ACTION_MESSAGE)}
      </div>
      <div className="cc__lighttext" style={{ marginTop: '8px' }}>
        {t(CALCULATOR_DEFAULTS_MESSAGE)}
      </div>
      <div style={{ marginTop: '8px' }}>
        {t('Pages customized: {{completed}}/{{total}}', {
          completed: customizedCount,
          total: CALCULATOR_PAGE_COUNT
        })}
      </div>
      {visitedCount >= CALCULATOR_PAGE_COUNT - 1 && !progress.summaryVisited &&
        <div style={{ marginTop: '10px' }}>
          <button
            type="button"
            className="btn btn-link"
            style={{ padding: 0, verticalAlign: 'baseline' }}
            onClick={() => postCalculatorNavigate('/results/summary')}
          >
            {t('Open Summary to finish')}
          </button>
        </div>
      }
    </Alert>
  );
};

export default withLocalization('calculator')(CalculatorProgressBanner) as React.SFC<Props>;
